const screenIsMobile = (): boolean => window.innerWidth < 767
export default screenIsMobile